import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import SignaturePad from '../../../components/SignaturePad/SignaturePad';
import Button from '@mui/material/Button';
import useSignatoryPage from './useSignatoryPage';
import Modal from '../../../components/Modal/Modal';
import ImageCard from '../../../components/Card/ImageCard';
import { Typography } from '@mui/material';



const SignatoryPage = ( {openedFile} ) => {

    const {
        sigPadRef,
        openSigPad,
        open,
        openedSignatory,
        modalBtnAction,
        signaturePadAction,
        onReset,
        isMounted,
        selectedFormSignatories
    } = useSignatoryPage(openedFile)
    
    return (
        <>
            <Grid container spacing={2} >
                {isMounted &&
                    selectedFormSignatories?.signatoryValues.length > 0 ?
                    selectedFormSignatories.signatoryValues.map((item) =>
                        <Grid xs={6} md={4} key={item.fieldName2} >
                            <ImageCard
                                title={item.name}
                                body={item.fieldName?.toUpperCase()}
                                image={item.signature}
                                key={item.fieldName2}
                                onClick={() => openSigPad(item)}
                            />
                        </Grid>
                    )
                    :
                    <Typography variant="h6" gutterBottom>
                        No required signatories are present in this form. 
                    </Typography>
                  
                }

            </Grid>

            <Modal
                isOpen={open}
                title={`Signature: ${openedSignatory.name}`}
                onModalClose={modalBtnAction.onClose}
                onModalSubmit={modalBtnAction.onSubmit}
            >
                <>
                    <SignaturePad
                        ref={sigPadRef}
                        signatory={openedSignatory}
                        showCanvas={onReset}
                    />
                    {openedSignatory.signature && !onReset?
                        <Button size="small" onClick={() => signaturePadAction.onReset()} >
                            Reset
                        </Button>
                        :
                        <Button size="small" onClick={() => signaturePadAction.onClear()} >
                            Clear
                        </Button>
                    }

                </>
            </Modal>
        </>

    );
}

export default SignatoryPage; 